import { bool, func, number, oneOf, shape } from 'prop-types';
import React from 'react';

import api from '../REST/api';
import withApiRequest from '../REST/with-api-request';
import ApprovalConfirmation from './ApprovalConfirmation';
import { APPROVAL_TYPES } from './constants';

function CreateApprovalButton({
  opportunityId,
  data,
  onSuccess,
  onRequest,
  loading,
  ...rest
}) {
  return (
    <ApprovalConfirmation
      onSuccess={onSuccess}
      onRequest={onRequest}
      opportunityId={opportunityId}
      data={data}
      disabled={loading}
      {...rest}
    />
  );
}

CreateApprovalButton.propTypes = {
  opportunityId: number.isRequired,
  onSuccess: func.isRequired,
  onRequest: func.isRequired,
  loading: bool.isRequired,
  data: shape({
    type: oneOf(Object.values(APPROVAL_TYPES)).isRequired,
    quoteId: number,
  }).isRequired,
};

export default withApiRequest({
  query: api.createApproval,
  error: 'flash',
  renderLoading: false,
  successMessage: 'Approval created successfully',
})(CreateApprovalButton);
